interface IExpandMoreProps
    extends Exclude<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        >,
        "ref"
    > {
    expand: boolean;
    siblingNode?: React.ReactNode;
    justify?: "center" | "start" | "end";
}

const ExpandMore = (props: IExpandMoreProps) => {
    const { expand, justify, siblingNode, children, ...other } = props;
    return (
        <div
            {...other}
            className={`d-flex align-items-center justify-content-${
                justify ?? "center"
            } ${props.className ?? ""}`}
            role="button"
        >
            {siblingNode}
            <span
                style={{
                    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
                    transition: "transform .3s",
                }}
            >
                {children}
            </span>
        </div>
    );
};

export default ExpandMore;
